/* eslint-disable */
'use strict';
import Helper from "./util/Helper";
// JavaScript to be fired on the home page
var $catPreview = $('.category-preview'),
  $catPreviewContent = $catPreview.find('.content'),
  $catPreviewBtn = $catPreview.find('.item .btn'),
  $latestNewsFilter = $('.block-latest-news form#filterNews'),
  $archiveNewsFilter = $('.news-container form#filterNews');

$latestNewsFilter.find('input[type="checkbox"]').on('change', function () {
  $latestNewsFilter.submit();
});
$archiveNewsFilter.find('input[type="checkbox"]').on('change', function () {
  $archiveNewsFilter.submit();
});


function submitFilter($reset) {
  let data = {
    action: 'filter_archive_posts',
    rm_nonce: ajax_scripts_vars.rm_nonce,
    postData: $archiveNewsFilter.serialize(),
    reset_pagination: $reset,
  };

  $.ajax({
    url: ajax_scripts_vars.rm_ajax_url,
    dataType: 'json',
    type: 'POST',
    data: data,
    success: function (data, textStatus, XMLHttpRequest) {
      if (textStatus === 'success' && data.status === 'success') {
        if (data.posts) {
          $('.news-container .blog-posts').html(data.posts);
        }
        if (data.reset) {
          $('input#paged').val(1);
        }
        if (data.pagination) {
          $('.posts-navigation').html(data.pagination);
        }
      } else {
        $('.news-container .blog-posts').html('<div class="alert alert-info" role="alert">' + ajax_scripts_vars.rm_empty_mrsg + '</div>');
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      $('.news-container .blog-posts').html('<div class="alert alert-danger" role="alert">' + ajax_scripts_vars.rm_error_mrsg + '</div>').fadeIn();
      console.error(errorThrown);
    }
  });
  return false;
}

$archiveNewsFilter.on('submit', function () {
  submitFilter(true);
  return false;
});

$(document).on('click', '.posts-navigation .nav-links a', function (e) {
  e.preventDefault();
  var paged = /[\?&]paged=(\d+)/.test(this.href) && RegExp.$1;

  paged = !paged ? 1 : paged;
  $('input#paged').val(paged);
  submitFilter(false);
  return false;
});

$latestNewsFilter.on('submit', function () {
  let data = {
    action: 'filter_latest_posts',
    rm_nonce: ajax_scripts_vars.rm_nonce,
    postData: $(this).serialize()
  };

  $.ajax({
    url: ajax_scripts_vars.rm_ajax_url,
    dataType: 'json',
    type: 'POST',
    data: data,
    success: function (data, textStatus, XMLHttpRequest) {
      if (textStatus === 'success' && data.first_post && data.status === 'success') {
        $('#articles .first').html(data.first_post);
        if (data.posts) {
          $('#articles .col-posts').html(data.posts);
        }
      } else {
        $('#articles .first').html('<div class="alert alert-info" role="alert">' + ajax_scripts_vars.rm_empty_mrsg + '</div>');
        $('#articles .col-posts').html('');
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      $('#articles .first').html('<div class="alert alert-danger" role="alert">' + ajax_scripts_vars.rm_error_mrsg + '</div>');
      $('#articles .col-posts').html('');
    }
  });
  return false;
});


if (Helper.smallScreenHelper(Helper.smBreakpoint)) {
  var $firstItem = $catPreview.find('.list > .item').first();
  $firstItem.find('.mobile-content').html($catPreviewContent.html());
  $catPreviewContent.html(null);
}
if (!Helper.smallScreenHelper(Helper.ipadMediumBreakpoint)) {
  $catPreview.find('.list .item').first().addClass('active');
}
$catPreviewBtn.on('click', function (e) {
  if (!Helper.smallScreenHelper(Helper.smBreakpoint) && $catPreview.find('.item.active').length) {
    $catPreview.find('.item.active').each(function (k, element) {
      $(element).removeClass('active');
    });
  }
  let $self = $(this),
    $item = $self.closest('.item'),
    $mobileContent = $item.find('.mobile-content');
  if (Helper.smallScreenHelper(Helper.smBreakpoint) && $mobileContent.find('.content-header').length) {
    $mobileContent.toggleClass('open');
    $mobileContent.slideToggle();
    if ($mobileContent.hasClass('open')) {
      $item.addClass('active');
    } else {
      $item.removeClass('active');
    }
  } else {
    let data = {
      action: 'filter_categories',
      rm_nonce: ajax_scripts_vars.rm_nonce,
      cat_id: $self.data('item')
    };

    $.ajax({
      url: ajax_scripts_vars.rm_ajax_url,
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function (data, textStatus, XMLHttpRequest) {
        if (textStatus === 'success' && data.category && data.status === 'success') {
          $item.addClass('active');
          if (!Helper.smallScreenHelper(Helper.smBreakpoint)) {
            $catPreviewContent.html(data.category);
          } else {
            $mobileContent.html(data.category);
          }
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
      },
      complete: function (data, textStatus) {
        if (Helper.smallScreenHelper(Helper.smBreakpoint) && textStatus === 'success' && data.responseJSON.status === 'success') {
          setTimeout(function () {
            $mobileContent.addClass('open');
            $mobileContent.slideDown();
          }, 100);
        }
      }
    });
  }
  return false;

});

$('.category-preview').on('click', '.load-more', function (e) {
  e.preventDefault();
  $(this).closest('.trim-items').find('.d-none').removeClass('d-none');
  $(this).remove();
});



// WEBPACK FOOTER //
// ./scripts/ajax-scripts.js